import type {PreviewProps, PreviewReturn} from '../types'

export const preview = ({
  title = '',
  media = '',
  prepare,
  ...props
}: PreviewProps = {}): PreviewReturn => ({
  select: {
    title,
    media,
    ...props,
  },
  prepare,
})
